import React from 'react';
import { Box } from '@mui/material';

interface GridItemProps {
  children: React.ReactNode;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
}

/**
 * A component to replace Grid item usage for MUI v7
 * This component uses Box to achieve the same layout effect
 */
const GridItem: React.FC<GridItemProps> = ({ 
  children, 
  xs = 12, 
  sm, 
  md, 
  lg,
  xl 
}) => {
  // Calculate widths based on the grid system (12 columns)
  const width = {
    xs: `${(xs / 12) * 100}%`,
    sm: sm ? `${(sm / 12) * 100}%` : undefined,
    md: md ? `${(md / 12) * 100}%` : undefined,
    lg: lg ? `${(lg / 12) * 100}%` : undefined,
    xl: xl ? `${(xl / 12) * 100}%` : undefined,
  };

  return (
    <Box
      sx={{
        width: { 
          xs: width.xs, 
          sm: width.sm, 
          md: width.md,
          lg: width.lg,
          xl: width.xl
        },
        px: 1,
        mb: 2
      }}
    >
      {children}
    </Box>
  );
};

export default GridItem; 